export default {
  OPEN_CODE_COMMISION_MODAL: 'OPEN_CODE_COMMISION_MODAL',
  OPEN_CODE_COMMISION_MODAL_SUCCESS: 'OPEN_CODE_COMMISION_MODAL_SUCCESS',
  CLOSE_CODE_COMMISION_MODAL: 'CLOSE_CODE_COMMISION_MODAL',
  FETCH_CODE_COMMISION_COMBO: 'FETCH_CODE_COMMISION_COMBO',
  FETCH_CODE_COMMISION_COMBO_SUCCESS: 'FETCH_CODE_COMMISION_COMBO_SUCCESS'
}
